module.exports = __webpack_public_path__ + "static/media/user.f47aa106.svg";